import { Chip, Grid } from '@mui/material';
import { useState } from 'react'
import { useAppContext } from '../../../libs/app-core/AppContext';
import { Toast } from '../../../libs/app-core/Toast';
import Label from '../../../libs/rhf-mui/ui/Label';
import Title from '../../../libs/rhf-mui/ui/Title';
import { debug_json_strinify } from '../../../libs/util/util_json';
import { UniForm } from '../../dao/UniForm';

type Props = {
  BaseFormList: UniForm[];
  SpwkFormList: UniForm[];
}

function Uc快取樹狀圖({ BaseFormList, SpwkFormList, ...props }: Props) {

  const ctx = useAppContext();

  const [CurrFormGuid, set_CurrFormGuid] = useState<string>("");

  return (
    <Grid container direction={'column'} spacing={1} padding={2}>
      <Grid item>
        <Title variant='subtitle2'>[Uc快取樹狀圖]</Title>
        <Title variant='body2'>BaseFormList x{BaseFormList.length}</Title>
        <Title variant='body2'>SpwkFormList x{SpwkFormList.length}</Title>
      </Grid>
      <Grid item container spacing={1}>
        {BaseFormList.map(x => <Grid item key={x.guid}>{render_Pill(x)}</Grid>)}
        {SpwkFormList.map(x => <Grid item key={x.guid}>{render_Pill(x)}</Grid>)}
      </Grid>
      <Grid item>
        {render_Tree()}
      </Grid>
    </Grid>
  )

  function render_Pill(x: UniForm): JSX.Element {
    return <Chip key={x.guid} label={x.func_code} onClick={() => { btn_Pill_Click(x); }} color={(x.guid === CurrFormGuid ? "primary" : undefined)} />;
  }

  function btn_Pill_Click(x: UniForm) {
    set_CurrFormGuid(x.guid);

    let json = GetFormJson(x.guid);
    navigator.clipboard.writeText(json);

    Toast.Show(ctx, "已複製樹狀圖: " + x.func_code);
  }

  function render_Tree() {
    let json = GetFormJson(CurrFormGuid);
    return <Label>{json}</Label>;
  }

  function GetFormJson(sel_form_guid: string) {
    let find = [...BaseFormList, ...SpwkFormList].find(x => x.guid === sel_form_guid);
    if (find == null) {
      return "";
    } else {
      return debug_json_strinify(find);
    }
  }



}

export default Uc快取樹狀圖

